import { useEffect, useState } from 'react';
import classNames from 'classnames';
import { useLocation, useNavigate } from 'react-router-dom';
import { Icon } from '@docs/kd-d2c-components';
import {
  eed_mario_icon_skillmarket_line,
  eed_mario_icon_hammer_line,
  eed_mario_icon_laboratory_line,
  eed_mario_icon_faker_line,
} from '@/assets/icons';
import { SidebarMenu } from '../menu/index.js';
import { useAIWindowContext } from '../../../Context/context.js';
import { useClawWs } from '@src/hooks/useClawWs';
import { collectLog } from '@src/utils/logger';
import {
  getSkillsOfficialUrl,
  shouldOpenSkillsInNewTabForLocal,
} from '@src/utils/route';
import {
  isMainagentPath,
  isPathUnderBase,
  MAINAGENT_DASHBOARD_PATH,
  MAINAGENT_ROUTE_BASE,
  MAINAGENT_WORKBENCH_PATH,
} from '@src/utils/mainagent-route';

/**
 * 仅用于侧边栏收起时 hover 浮层，样式与交互独立于展开态 SidebarHeader。
 */
export const FloatMenuHoverContent = () => {
  const { toConversion } = useAIWindowContext();
  const { switchSession } = useClawWs();
  const location = useLocation();
  const navigate = useNavigate();
  const [activeModeTab, setActiveModeTab] = useState<'claw' | 'normal'>(
    'normal',
  );

  const isClawActive = isMainagentPath(location.pathname);
  const isSkillsActive =
    location.pathname === '/skills' || location.pathname.startsWith('/skills/');
  const isClawWorkbenchActive =
    isPathUnderBase(location.pathname, MAINAGENT_WORKBENCH_PATH) ||
    isPathUnderBase(location.pathname, MAINAGENT_DASHBOARD_PATH);

  const isDigitalActive =
    location.pathname === '/lab' || location.pathname.startsWith('/lab/');
  const isAgentsActive =
    location.pathname === '/agents' || location.pathname.startsWith('/agents/');
  const isClawModeTabActive =
    isClawActive || isSkillsActive || isDigitalActive || isAgentsActive;
  const showClawModeNav = activeModeTab === 'claw';

  useEffect(() => {
    setActiveModeTab(isClawModeTabActive ? 'claw' : 'normal');
  }, [isClawModeTabActive]);

  return (
    <div className="kim-ai-mario-float-menu-hover">
      <div className="kim-ai-mario-float-menu-hover__top">
        <div className="kim-ai-mario-float-menu-hover__tabs">
          <div
            className={classNames('kim-ai-mario-float-menu-hover__tab', {
              'is-active': activeModeTab === 'claw',
            })}
            onClick={() => {
              setActiveModeTab('claw');
              switchSession('');
              navigate(MAINAGENT_ROUTE_BASE);
            }}
          >
            Mario
          </div>
          <div
            className={classNames('kim-ai-mario-float-menu-hover__tab', {
              'is-active': activeModeTab === 'normal',
            })}
            onClick={() => {
              setActiveModeTab('normal');
              toConversion('');
            }}
          >
            普通任务
          </div>
        </div>
        {showClawModeNav && (
          <div className="kim-ai-mario-float-menu-hover__nav">
            <div
              className={classNames('kim-ai-mario-float-menu-hover__nav-item', {
                'is-active': isAgentsActive,
              })}
              onClick={() => {
                switchSession('');
                navigate('/agents');
              }}
            >
              <Icon size={20} icon={eed_mario_icon_faker_line} />
              <span className="kim-ai-mario-float-menu-hover__nav-text">
                数字员工
              </span>
            </div>
            <div
              className={classNames('kim-ai-mario-float-menu-hover__nav-item', {
                'is-active': isSkillsActive,
              })}
              onClick={() => {
                collectLog('MAIN', { action: 'PAGE_VIEW_MARKET' }, 'CLICK');
                switchSession('');
                if (shouldOpenSkillsInNewTabForLocal()) {
                  window.open(getSkillsOfficialUrl('/skills'), '_blank');
                  return;
                }
                navigate('/skills');
              }}
            >
              <Icon size={20} icon={eed_mario_icon_skillmarket_line} />
              <span className="kim-ai-mario-float-menu-hover__nav-text">
                Mario 集市
              </span>
            </div>
            <div
              className={classNames('kim-ai-mario-float-menu-hover__nav-item', {
                'is-active': isClawWorkbenchActive,
              })}
              onClick={() => {
                navigate(MAINAGENT_DASHBOARD_PATH);
              }}
            >
              <Icon size={20} icon={eed_mario_icon_hammer_line} />
              <span className="kim-ai-mario-float-menu-hover__nav-text">
                工作台
              </span>
            </div>
            <div
              className={classNames('kim-ai-mario-float-menu-hover__nav-item', {
                'is-active': isDigitalActive,
              })}
              onClick={() => {
                navigate('/lab');
              }}
            >
              <Icon size={20} icon={eed_mario_icon_laboratory_line} />
              <span className="kim-ai-mario-float-menu-hover__nav-text">
                Mario Team
              </span>
              <span className="kim-ai-mario-sidebar-nav-item-badge">Beta</span>
            </div>
          </div>
        )}
      </div>
      <div className="kim-ai-mario-float-menu-hover__body">
        <SidebarMenu />
      </div>
    </div>
  );
};
